import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionLaboratoryPersonnelsApi = {
    getTrialInstitutionLaboratoryPersonnels: (): Observable<Dtos.GetTrialInstitutionLaboratoryPersonnelsResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryPersonnels = new Dtos.GetTrialInstitutionLaboratoryPersonnels();

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryPersonnelsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoryPersonnelById: (id: number): Observable<Dtos.GetTrialInstitutionLaboratoryPersonnelByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryPersonnelById = new Dtos.GetTrialInstitutionLaboratoryPersonnelById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryPersonnelByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoryPersonnelByLaboratoryId: (trialInstitutionLaboratoryId: number): Observable<Dtos.GetTrialInstitutionLaboratoryPersonnelByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryPersonnelByLaboratoryId = new Dtos.GetTrialInstitutionLaboratoryPersonnelByLaboratoryId();

        request.trialInstitutionLaboratoryId = trialInstitutionLaboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryPersonnelByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionLaboratoryPersonnel: (trialInstitutionLaboratoryPersonnel: Dtos.TrialInstitutionLaboratoryPersonnel): Observable<Dtos.SetTrialInstitutionLaboratoryPersonnelResponse> => {

        let request: Dtos.SetTrialInstitutionLaboratoryPersonnel = new Dtos.SetTrialInstitutionLaboratoryPersonnel();

        request.trialInstitutionLaboratoryPersonnel = trialInstitutionLaboratoryPersonnel;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionLaboratoryPersonnelResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialInstitutionLaboratoryPersonnel: (trialInstitutionLaboratoryId: number): Observable<Dtos.CreateTrialInstitutionLaboratoryPersonnelResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionLaboratoryPersonnel = new Dtos.CreateTrialInstitutionLaboratoryPersonnel();

        request.trialInstitutionLaboratoryId = trialInstitutionLaboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionLaboratoryPersonnelResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionLaboratoryPersonnel: (trialInstitutionLaboratoryPersonnel: Dtos.TrialInstitutionLaboratoryPersonnel): Observable<Dtos.ValidateTrialInstitutionLaboratoryPersonnelResponse> => {

        let request: Dtos.ValidateTrialInstitutionLaboratoryPersonnel = new Dtos.ValidateTrialInstitutionLaboratoryPersonnel();

        request.trialInstitutionLaboratoryPersonnel = trialInstitutionLaboratoryPersonnel;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionLaboratoryPersonnelResponse> = client.post(request);

        return Observable.from(response);

    }
}